import { render, staticRenderFns } from "./registrarPlanilla.vue?vue&type=template&id=76b99c06&"
import script from "./registrarPlanilla.vue?vue&type=script&lang=js&"
export * from "./registrarPlanilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports